/**
 * Abstracted handling of message display to the UX layer
 */
mmf_modules.define('messaging',[
    'utils/ux',
    'console'
], function (
    mmf_ux,
    console
) {
    'use strict';

    var LEVELS = {
        'ERROR': 'error',
        'INFO': 'info',
        'WARNING': 'warning'
    };

    var display = function (msg, auto_close, level) {
        mmf_ux.Messaging.View(msg, auto_close);
    };

    return {
        error: function (msg, auto_close) { display.call(this, msg, auto_close, LEVELS.ERROR); },
        info: function (msg, auto_close) { display.call(this, msg, auto_close, LEVELS.INFO); },
        warning: function (msg, auto_close) { display.call(this, msg, auto_close, LEVELS.WARNING); }
    };
});

